import logo from '../../../../assets/img/logo.png';

/**
 * @ngdoc controller
 * @name MenuBarController
 * @description
 * This component renders the Menu Bar.
 *
 * @memberof rootModule
 */
class MenuBarController {
  /**
   * Class constructor.
   * @param {Object}  $rootScope  To listen for the necessary events.
   * @param {Service} appUtils    To get the Admin accounts.
   * @param {Service} ccaSession  To get the current session.
   * @param {Object}  AUTH_EVENTS The name of the events the method needs to listen for.
   * @ignore
   */
  constructor(
    $rootScope,
    appUtils,
    ccaSession,
    AUTH_EVENTS,
  ) {
    'ngInject';

    /**
     * The local reference to the `$rootScope` object.
     * @type {Object}
     */
    this.$rootScope = $rootScope;
    /**
     * The local reference to the `appUtils` service.
     * @type {Object}
     */
    this.appUtils = appUtils;
    /**
     * The local reference to the `AUTH_EVENTS` constant.
     * @type {Object}
     */
    this.AUTH_EVENTS = AUTH_EVENTS;
    /**
     * The local reference to the `logo` image.
     * @type {String}
     */
    this.logo = logo;
    /**
     * Local reference if the selector menu should be shown or not.
     * @type {Boolean}
     */
    this.isSelectorMenuVisible = false;

    const session = ccaSession.getSession() || { accounts: [] };
    /**
     * The local reference to the `account` object.
     * @type {Object}
     */
    this.account = ccaSession.getSelectedAccount();
    /**
     * Local reference if the user has more than one account.
     * @type {Boolean}
     */
    this.hasMultipleAccounts = this.appUtils.getAdminAccounts(session.accounts).length > 1;
  }
  /**
   * Start to listen the authorization events.
   */
  $onInit() {
    this.removeLoginSuccess = this.$rootScope
    .$on(this.AUTH_EVENTS.loginSuccess, (event, session) => {
      this.hasMultipleAccounts = this.appUtils.getAdminAccounts(session.accounts).length > 1;
    });

    this.removeCustomerChanged = this.$rootScope
    .$on(this.AUTH_EVENTS.customerChanged, (event, account) => {
      this.account = account;
    });
  }
  /**
   * When this component gets destroyed, unsubscribe to all events in order to prevent memory
   * leaks.
   */
  $onDestroy() {
    this.removeLoginSuccess();
    this.removeCustomerChanged();
  }
  /**
   * Handle the show or hide of the selector menu.
   */
  toggleSelectorMenu() {
    this.isSelectorMenuVisible = !this.isSelectorMenuVisible;
  }
}

export default MenuBarController;



// WEBPACK FOOTER //
// ./src/frontend/modules/root/components/menuBar/menuBar.controller.js